import gql from 'graphql-tag';

import lessonTemplateFragment from '~/shared/graphql-queries/lesson-templates/lesson-template-fragment';

export default gql`
  query findByIdLessonTemplateQuery($_id: MongoID!) {
    findByIdLessonTemplateQuery(_id: $_id) {
      ...LessonTemplateFragment
    }
  }
  ${lessonTemplateFragment}
`;
